<h2 mat-dialog-title>{{ 'account.dialogs.mfa.delete.title' | t }}</h2>
<mat-dialog-content class="fixed-size-dialog">
  <p>{{ 'account.dialogs.mfa.delete.description' | t }}</p>
  <p>{{ 'account.dialogs.mfa.delete.securityNote' | t }}</p>

  <mat-error *ngIf="errorMessage" class="error-container">
    <span>{{ errorMessage }}</span>
  </mat-error>

  <sn-form [form]="verificationForm" [fields]="formFields" [(model)]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button
    mat-button
    color="warn"
    [disabled]="verificationForm.invalid"
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    (click)="confirm()"
  >
    {{ 'common.delete' | t }}
  </button>
</mat-dialog-actions>
